@if (router.url != '/') {
  <div fxLayout="row wrap">
    <div fxFlex="100">
      <mat-card appearance="outlined" fxLayout="row" class="breadcrumb light-block">
        @if (router.url != '/') {
          <a routerLink="/" class="breadcrumb-item" fxLayout="row" fxLayoutAlign="start center" (click)="closeSubMenus()">
            <mat-icon>home</mat-icon>
            <span class="breadcrumb-title">{{'sale4you.label.Product.homepage' | translate}}</span>
          </a>
        }
        @for (breadcrumb of breadcrumbs; track breadcrumb; let i = $index) {
          <div class="breadcrumb-item" fxLayout="row" fxLayoutAlign="start center">
            <a [hidden]="i == (breadcrumbs.length - 1)" [routerLink]="[breadcrumb.url]">{{breadcrumb.name | translate}}</a>
            <span [hidden]="i != (breadcrumbs.length - 1)" class="breadcrumb-title active"><b>{{breadcrumb.name | translate}}</b></span>
          </div>
        }
      </mat-card>
    </div>
  </div>
}

